export default __webpack_public_path__ + "assets/images/turtlerace-6025171eebe2f10b370594f56c66c2ae.svg";